import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import Applications from "../../components/User/Applications";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const DraftApplications = () => {
  const { language, setLanguage } = useLanguage();
  return (
    <DashboardLayout pageTitle={language ? "आवेदन" : "Application"} mainClass="p-6">
      <Applications
        title={language ? "अधूरा आवेदन" : "Draft Applications"}
        status={[applicationStatusMap?.draft]}
      />
    </DashboardLayout>
  );
};

export default DraftApplications;
